import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Breadcrumbs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MotionCard = motion(Card);

const purple      = "#4B3FA0";
const purpleMid   = "#7166C8";
const purpleLight = "rgba(75,63,160,0.07)";
const purpleBorder= "rgba(75,63,160,0.22)";
const green       = "#4B3FA0";
const greenLight  = "rgba(101,166,48,0.10)";

const tarifas = [
  { label: "1 Participante",              hasta30jun: "US$290.00 / QTZ 2,320.00",    del01jul: "US$325.00 / QTZ 2,600.00"    },
  { label: "3 Participantes en adelante", hasta30jun: "—",            del01jul: "US$290.00 / QTZ 2,320.00 c/u" },
];

const includes = [
  "Conferencias",
  "Refrigerios a.m. y p.m.",
  "Almuerzos",
  "Acceso al área de stands",
  "Certificado digital",
];

export default function Tarifas() {
  return (
    <Stack
      spacing={0}
      alignItems="center"
      sx={{ background: "#f4f5f7", width: "100%", minHeight: "100vh" }}
    >
      {/* ── BREADCRUMB ── */}
      <Box sx={{ width: "100%", pt: 2.5, pb: 1, px: 3, background: "#f4f5f7", display: "flex", justifyContent: "center" }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 15 }}>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              color: "inherit",
              textDecoration: "none",
              fontSize: 15,
            }}
          >
            <HomeIcon sx={{ fontSize: 18 }} />
            Inicio
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: 15, color: purple }}
          >
            <AttachMoneyIcon sx={{ fontSize: 18 }} />
            Tarifas
          </Typography>
        </Breadcrumbs>
      </Box>

      {/* ── MAIN CONTENT ── */}
      <Box sx={{ width: "100%", py: 6 }}>
        <Container maxWidth="md">

          {/* HEADER */}
          <Box mb={5}>
            <Typography
              variant="overline"
              sx={{ color: purple, fontWeight: 600, letterSpacing: 2, fontSize: 11 }}
            >
              III Congreso Latinoamericano de Desarrollo del Talento Humano
            </Typography>
            <Typography variant="h4" fontWeight={700} sx={{ color: purple, mt: 0.5 }}>
              TARIFAS CLADE 2026
            </Typography>
            <Box sx={{ width: 52, height: 3, background: green, borderRadius: 2, mt: 1.5, mb: 2 }} />
          </Box>

          {/* TEMA CARD */}
          <MotionCard
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
            sx={{
              borderRadius: 3,
              p: "1.25rem 1.5rem",
              mb: 4,
              background: "#fff",
              border: `1px solid ${purpleBorder}`,
              borderLeft: `4px solid ${purple}`,
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                background: purpleLight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <AutoAwesomeIcon sx={{ color: purple, fontSize: 20 }} />
            </Box>
            <Box>
              <Typography
                variant="overline"
                sx={{ color: purpleMid, fontWeight: 600, letterSpacing: 1.5, fontSize: 10 }}
              >
                Tema del congreso
              </Typography>
              <Typography variant="h6" fontWeight={700} sx={{ color: purple, lineHeight: 1.3 }}>
                Construyendo Empresas Sostenibles con IA
              </Typography>
              <Typography variant="body2" sx={{ color: "#666", mt: 0.25 }}>
                Personas, propósito y regulación ESG
              </Typography>
            </Box>
          </MotionCard>

          {/* TABLA DE TARIFAS */}
          <Typography
            variant="overline"
            sx={{ color: green, fontWeight: 600, letterSpacing: 2, fontSize: 11, display: "block", mb: 1.5 }}
          >
            Inscripción
          </Typography>

          <MotionCard
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid #ddd",
              boxShadow: "none",
              mb: 1,
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ background: "#fff", borderBottom: "none", width: "38%" }} />
                    <TableCell
                      align="center"
                      sx={{
                        background: purple,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        py: 2,
                        lineHeight: 1.3,
                      }}
                    >
                      Hasta el<br />30/06/2026
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        background: purpleMid,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        py: 2,
                        lineHeight: 1.3,
                      }}
                    >
                      Del 01/07 hasta<br />el día del evento
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tarifas.map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{
                        background: i % 2 === 0 ? purpleLight : "#fff",
                        "&:last-child td": { border: 0 },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600, fontSize: "0.95rem", color: "#2d2d2d", py: 2.5, pl: 3 }}>
                        {row.label}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 600,
                          fontSize: "1rem",
                          color: row.hasta30jun === "—" ? "#bbb" : purple,
                          py: 2.5,
                        }}
                      >
                        {row.hasta30jun}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: 600, fontSize: "1rem", color: purple, py: 2.5 }}
                      >
                        {row.del01jul}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </MotionCard>

          <Box display="flex" justifyContent="flex-end" mb={5}>
            <Typography variant="caption" sx={{ color: "#999", fontStyle: "italic" }}>
              IVA incluido
            </Typography>
          </Box>

          {/* INCLUYE */}
          <Typography
            variant="overline"
            sx={{ color: green, fontWeight: 600, letterSpacing: 2, fontSize: 11, display: "block", mb: 1.5 }}
          >
            La inscripción incluye
          </Typography>

          <Grid container spacing={2}>
            {includes.map((item, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <MotionCard
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: i * 0.07 }}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    height: "100%",
                    background: "#fff",
                    border: "1px solid #e8e8e8",
                    boxShadow: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: 2,
                      background: purpleLight,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <CheckCircleIcon sx={{ color: green, fontSize: 18 }} />
                  </Box>
                  <Typography variant="body2" fontWeight={500} sx={{ color: "#333", lineHeight: 1.3 }}>
                    {item}
                  </Typography>
                </MotionCard>
              </Grid>
            ))}
          </Grid>

        </Container>
      </Box>
    </Stack>
  );
}